import { render, staticRenderFns } from "./SubjectDetail.vue?vue&type=template&id=da590f92&"
import script from "./SubjectDetail.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports